module.exports = __webpack_public_path__ + "static/stopklatka-3-3b2d1da88a8461c29cfa63df27a3574d.jpg";